export default __webpack_public_path__ + "static/media/cleanproReload3.6796627c.png";